const LOVALO_CURRENCY_PATTERN = /\b(?:NIS|ILS)\b/g;

function replaceCurrencyText(root) {
  if (!root) return;

  const replaceTextNode = (node) => {
    LOVALO_CURRENCY_PATTERN.lastIndex = 0;
    if (!LOVALO_CURRENCY_PATTERN.test(node.nodeValue || '')) return;
    LOVALO_CURRENCY_PATTERN.lastIndex = 0;
    node.nodeValue = node.nodeValue.replace(LOVALO_CURRENCY_PATTERN, '₪');
  };

  if (root.nodeType === Node.TEXT_NODE) {
    replaceTextNode(root);
    return;
  }

  if (!(root instanceof Element) && root !== document) return;

  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent || parent.closest('script, style, noscript, textarea')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    },
  });

  while (walker.nextNode()) replaceTextNode(walker.currentNode);

  const elements = root instanceof Element
    ? [root, ...root.querySelectorAll('[value], [aria-label], [data-variant-price]')]
    : [...document.querySelectorAll('[value], [aria-label], [data-variant-price]')];
  elements.forEach((element) => {
    ['value', 'aria-label', 'data-variant-price'].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      LOVALO_CURRENCY_PATTERN.lastIndex = 0;
      if (!value || !LOVALO_CURRENCY_PATTERN.test(value)) return;
      LOVALO_CURRENCY_PATTERN.lastIndex = 0;
      element.setAttribute(attribute, value.replace(LOVALO_CURRENCY_PATTERN, '₪'));
    });
  });
}

function initializeLovaloCurrency() {
  replaceCurrencyText(document.body);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        replaceCurrencyText(mutation.target);
        return;
      }

      if (mutation.type === 'attributes') {
        replaceCurrencyText(mutation.target);
        return;
      }

      mutation.addedNodes.forEach(replaceCurrencyText);
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['value', 'aria-label', 'data-variant-price'],
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeLovaloCurrency, { once: true });
} else {
  initializeLovaloCurrency();
}
